// Simplified API service for handling reviews - Vercel deployment

// Function to fetch reviews from the MongoDB database
export const fetchReviews = async () => {
  try {
    console.log('Calling /api/reviews...');
    
    // Using relative path for API call which works in both local and production
    const response = await fetch('/api/reviews');

    if (!response.ok) {
      const errorText = await response.text();
      console.error('Error fetching reviews:', errorText);
      throw new Error(`Failed to fetch reviews: ${response.status} ${response.statusText}`);
    }

    const data = await response.json();
    console.log('Fetched reviews:', data);
    return data;
  } catch (error) {
    console.error('Error in fetchReviews service:', error);
    throw error;
  }
};

// Function to submit a new review to the MongoDB database
export const submitReview = async (review) => {
  try {
    console.log('Submitting review to API:', review);
    
    // Using relative path for API call which works in both local and production
    const response = await fetch('/api/reviews', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(review),
    });

    if (!response.ok) {
      const errorText = await response.text();
      console.error('Error submitting review:', errorText);
      throw new Error(`Failed to submit review: ${response.status} ${response.statusText}`);
    }

    const data = await response.json();
    console.log('Review submitted successfully:', data);
    return data;
  } catch (error) {
    console.error('Error in submitReview service:', error);
    throw error;
  }
};
